import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { ImportHistoryItem } from '../../models/ImportHistoryModel';
import { ImportHistoryCard } from './ImportHistoryCard';

interface ImportHistoryCardListProps {
  items: ImportHistoryItem[];
  isLoading?: boolean;
  className?: string;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: any;
  onSortingChange?: (sorting: any) => void;
  total?: number;
  onViewDetails: (item: ImportHistoryItem) => void;
  onRetry: (item: ImportHistoryItem) => void;
}

export const ImportHistoryCardList = ({
  items,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  sorting,
  onSortingChange,
  total,
  className = '',
  onViewDetails,
  onRetry,
}: ImportHistoryCardListProps) => {
  const { t } = useTranslation('shopsModule');

  const renderCard = (props: RenderItemProps<ImportHistoryItem>) => (
    <ImportHistoryCard {...props} onViewDetails={onViewDetails} onRetry={onRetry} />
  );

  const getItemKey = (item: ImportHistoryItem) => item.id;

  return (
    <VirtualList
      data={items}
      renderItem={renderCard}
      itemKey={getItemKey}
      estimateItemHeight={130}
      height="calc(100vh - 150px)"
      gap={0}
      emptyMessage={t('empty.message')}
      className={`rounded-lg shadow-sm ${className}`}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      sorting={sorting}
      onSortingChange={onSortingChange}
      total={total}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
